import { render } from "./bpjsconfirmationreport.vue?vue&type=template&id=4c88bc9b"
import script from "./bpjsconfirmationreport.vue?vue&type=script&lang=js"
export * from "./bpjsconfirmationreport.vue?vue&type=script&lang=js"

import exportComponent from "/home/runner/work/backoffice_jempolku_hijau/backoffice_jempolku_hijau/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__